import * as React from 'react';
import Particles from 'react-particles-js';
import { RenderDiv } from 'source/app/presentation/Shared/Render';
import { ESharedFunction } from 'motw_core/Enums/ESharedFunction';
import { ShareState } from '../../../../../services/UI/State/ShareState';
import { StyleClass } from '../../../../Shared/Styles/CSS';

export function LogInputParticles() {
	const [ show, setShow ] = React.useState(false); // false

	ShareState(ESharedFunction.LogInputParticles_show, show, setShow);

	return (
		<RenderDiv
			id="logInputParticles"
			when={show}
			withClasses={StyleClass(`logInputParticlesFadeControl`, {
				opacity: 1,
				transition: 'all 7s'
			})}
		>
			<Particles
				height={`${window.outerHeight}px`}
				width={`${window.outerWidth}px`}
				params={GetParticleParameters('#FFD700')}
			/>
		</RenderDiv>
	);
}

function GetParticleParameters(cssColor: string) {
	return {
		particles: {
			number: {
				value: 180,
				density: {
					enable: true,
					value_area: 473.4885849793636
				}
			},
			color: {
				value: cssColor
			},
			opacity: {
				value: 0.5,
				random: true,
				anim: {
					enable: true,
					speed: 1,
					opacity_min: 0.1,
					sync: true
				}
			},
			size: {
				value: 11.83721462448409,
				random: true,
				anim: {
					enable: true,
					speed: 30,
					size_min: 0.1,
					sync: false
				}
			},
			line_linked: {
				enable: false
			},
			move: {
				enable: true
			}
		},
		retina_detect: true
	};
}
